import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["operation"];
import quickFetch from 'quick-fetch';
import { stableStringify } from './internal/stableStringify';
const makeGqlEarlyRequest = options => {
  const {
      operation
    } = options,
    rest = _objectWithoutPropertiesLoose(options, _excluded);
  const requestName = stableStringify({
    operationName: operation.operationName,
    variables: operation.variables || {}
  });
  quickFetch.makeEarlyRequest(requestName, Object.assign({}, rest, {
    type: 'POST',
    data: JSON.stringify(operation),
    dataType: 'json',
    contentType: 'application/json'
  }));
};
const getGqlEarlyRequest = ({
  operationName,
  variables
}) => {
  const requestName = stableStringify({
    operationName,
    variables: variables || {}
  });
  const requestState = quickFetch.getRequestStateByName(requestName);
  if (requestState && !requestState.error) {
    return new Promise((resolve, reject) => {
      requestState.whenFinished(response => {
        quickFetch.removeEarlyRequest(requestName);
        resolve(response);
      });
      requestState.onError((_, errorMessage) => {
        quickFetch.removeEarlyRequest(requestName);
        reject(errorMessage);
      });
    });
  }
  return null;
};
export { getGqlEarlyRequest, makeGqlEarlyRequest };